/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const scenarioMessages = defineMessages({
    mainTitle: {
        id: 'portal.homePageScenarios.mainTitle',
        defaultMessage: 'Explore Language Understanding scenarios'
    },
    informationChatBotTitle: {
        id: 'portal.homePageScenarios.informationChatBotTitle',
        defaultMessage: 'Information Chat bot'
    },
    learnMoreChatBot: {
        id: 'portal.homePageScenarios.learnMoreChatBot',
        defaultMessage: 'Learn more about chat bot'
    },
    informationChatBotDescription: {
        id: 'portal.homePageScenarios.informationChatBotDescription',
        defaultMessage: `This Informational Bot can answer questions defined in a knowledge
set or FAQ using Cognitive Services QnA Maker and answer more open-ended questions using
Azure Search.`
    },
    informationChatBotQuote: {
        id: 'portal.homePageScenarios.informationChatBotQuote',
        defaultMessage: `"Conversation as a platform is the future, so it’s great that we’re
already offering it to our customers using the Bot Framework and Azure."`
    },
    informationChatBotCustomer: {
        id: 'portal.homePageScenarios.informationChatBotCustomer',
        defaultMessage: 'Katie Duffy: Application Architect UPS'
    },
    informationChatBotDeepLink: {
        id: 'portal.homePageScenarios.informationChatBotDeepLink',
        defaultMessage: 'See how UPS is helping customers to track their package in real time >'
    },
    informationChatBotBullet1: {
        id: 'portal.homePageScenarios.informationChatBotBullet1',
        defaultMessage: 'Employee starts the Application Bot'
    },
    informationChatBotBullet2: {
        id: 'portal.homePageScenarios.informationChatBotBullet2',
        defaultMessage: 'Azure Active Directory validates the employee’s identity'
    },
    informationChatBotBullet3: {
        id: 'portal.homePageScenarios.informationChatBotBullet3',
        defaultMessage: 'The employee can ask the bot what type of queries are supported'
    },
    informationChatBotBullet4: {
        id: 'portal.homePageScenarios.informationChatBotBullet4',
        defaultMessage: 'Cognitive Services returns a FAQ built with the QnA Maker'
    },
    informationChatBotBullet5: {
        id: 'portal.homePageScenarios.informationChatBotBullet5',
        defaultMessage: 'The employee defines a valid query'
    },
    informationChatBotBullet6: {
        id: 'portal.homePageScenarios.informationChatBotBullet6',
        defaultMessage: 'The Bot submits the query to Azure Search which returns information about the application data'
    },
    informationChatBotBullet7: {
        id: 'portal.homePageScenarios.informationChatBotBullet7',
        defaultMessage: 'Application insights gathers runtime telemetry to help development with Bot performance and usage'
    },
    iotDevicesTitle: {
        id: 'portal.homePageScenarios.iotDevicesTitle',
        defaultMessage: 'IoT Devices'
    },
    learnMoreIot: {
        id: 'portal.homePageScenarios.learnMoreIot',
        defaultMessage: 'Learn more about IoT devices'
    },
    iotDevicesDescription: {
        id: 'portal.homePageScenarios.iotDevicesDescription',
        defaultMessage: `Create seamless conversational interfaces with all of your internet accessible devices. From
your connected television, fridge to devices in a connected power plant. LUIS is able to integrate up to 500 intents
to translate commands into smart actions`
    },
    iotDevicesQuote: {
        id: 'portal.homePageScenarios.iotDevicesQuote',
        defaultMessage: `"It’s really simple and seamless to move data into the cloud. And if customers want to apply
machine learning or predictive analytics, they can do so without additional complexity."`
    },
    iotDevicesCustomer: {
        id: 'portal.homePageScenarios.iotDevicesCustomer',
        defaultMessage: 'John Dyck: Software Business Development Director at Rockwell Automation'
    },
    iotDevicesDeepLink: {
        id: 'portal.homePageScenarios.iotDevicesDeepLink',
        defaultMessage: 'See how Rockwell Automation is leveraging Microsoft’s IoT Suite >'
    },
    iotDevicesBullet1: {
        id: 'portal.homePageScenarios.iotDevicesBullet1',
        defaultMessage: 'User logs into Skype and accesses the IoT Bot'
    },
    iotDevicesBullet2: {
        id: 'portal.homePageScenarios.iotDevicesBullet2',
        defaultMessage: 'Using voice the user asks the Bot to turn on the lights via the IoT device'
    },
    iotDevicesBullet3: {
        id: 'portal.homePageScenarios.iotDevicesBullet3',
        defaultMessage: 'The request is relayed to a 3rd party service that has access to the IoT device network'
    },
    iotDevicesBullet4: {
        id: 'portal.homePageScenarios.iotDevicesBullet4',
        defaultMessage: 'The results of the command are returned to the user'
    },
    iotDevicesBullet5: {
        id: 'portal.homePageScenarios.iotDevicesBullet5',
        defaultMessage: 'Application insights gathers runtime telemetry to help development with Bot performance and usage'
    },
    commerceChatBotTitle: {
        id: 'portal.homePageScenarios.commerceChatBotTitle',
        defaultMessage: 'Commerce Chat bot'
    },
    learnMoreCommerceChatBot: {
        id: 'portal.homePageScenarios.learnMoreCommerceChatBot',
        defaultMessage: 'Learn more about commerce chat bot'
    },
    commerceChatBotDescription: {
        id: 'portal.homePageScenarios.commerceChatBotDescription',
        defaultMessage: `Together, Language Understanding and Azure Bot Service enable developers to create conversational
interfaces for various scenarios like banking, travel, and entertainment. For example, a hotel’s concierge can use a bot to
enhance traditional e-mail and phone call interactions by validating a customer via Azure Active Directory and using Cognitive
Services to better contextually process customer requests using text and voice. The Speech recognition service can be added
to support voice commands.`
    },
    commerceChatBotQuote: {
        id: 'portal.homePageScenarios.commerceChatBotQuote',
        defaultMessage: `"It’s amazing once development started how quickly the whole thing came together… We didn’t need to
build any special functionality to connect the bot to our product catalog and stock data—we just used existing feeds."`
    },
    commerceChatBotCustomer: {
        id: 'portal.homePageScenarios.commerceChatBotCustomer',
        defaultMessage: 'Antonia Colin-Jones: Strategic Partnership Program Manager Dixons Carphone'
    },
    commerceChatBotDeepLink: {
        id: 'portal.homePageScenarios.commerceChatBotDeepLink',
        defaultMessage: 'See how Dixons Carphone is interacting with customers >'
    },
    commerceChatBotBullet1: {
        id: 'portal.homePageScenarios.commerceChatBotBullet1',
        defaultMessage: 'Customer uses your mobile app'
    },
    commerceChatBotBullet2: {
        id: 'portal.homePageScenarios.commerceChatBotBullet2',
        defaultMessage: 'Using Azure AD B2C, the user authenticates'
    },
    commerceChatBotBullet3: {
        id: 'portal.homePageScenarios.commerceChatBotBullet3',
        defaultMessage: 'Using the custom Application Bot, user requests information'
    },
    commerceChatBotBullet4: {
        id: 'portal.homePageScenarios.commerceChatBotBullet4',
        defaultMessage: 'Cognitive Services helps process the natural language request'
    },
    commerceChatBotBullet5: {
        id: 'portal.homePageScenarios.commerceChatBotBullet5',
        defaultMessage: 'Response is reviewed by customer who can refine the question using natural conversation'
    },
    commerceChatBotBullet6: {
        id: 'portal.homePageScenarios.commerceChatBotBullet6',
        defaultMessage: 'Once the user is happy with the results, the Application Bot updates the customer’s reservation'
    },
    commerceChatBotBullet7: {
        id: 'portal.homePageScenarios.commerceChatBotBullet7',
        defaultMessage: 'Application insights gathers runtime telemetry to help development with Bot performance and usage'
    }
});
